import React from 'react';
import { I18n } from 'react-redux-i18n';

import { I18N_BASE } from '../../constants';
import { BodyHashClusterItem } from '../../models';
import { clusterItemLabel } from '../../helpers/clusterItemLabel';
import CmCheckbox from '../../components/primitives/CmCheckbox';
import ScorePill from '../../components/ScorePill/ScorePill';
import styles from './review.module.css';

export interface BodyHashClusterSectionProps {
  items: BodyHashClusterItem[];
  selectedIds: number[];
  onToggle: (id: number) => void;
  testId?: string;
}

export function BodyHashClusterSection({
  items,
  selectedIds,
  onToggle,
  testId,
}: BodyHashClusterSectionProps): React.ReactElement | null {
  if (items.length === 0) return null;

  return (
    <section className={styles.clusterCard} data-testid={testId}>
      <div className={styles.fieldLabel}>
        {I18n.t(`${I18N_BASE}.detail.bodyHash.title`, { count: items.length })}
      </div>
      {items.map((item) => {
        const checked = selectedIds.includes(item.contentModerationEventId);
        return (
          <div className={styles.duplicateRow} key={item.contentModerationEventId}>
            <div className={styles.duplicateLeft}>
              <CmCheckbox
                checked={checked}
                onChange={() => onToggle(item.contentModerationEventId)}
                testId={`bodyhash-checkbox-${item.contentModerationEventId}`}
                ariaLabel={I18n.t(`${I18N_BASE}.general.selectEventAriaLabel`, {
                  id: item.contentModerationEventId,
                })}
              />
              <span>{clusterItemLabel(item)}</span>
            </div>
            <ScorePill score={item.aiScore} size="small" />
          </div>
        );
      })}
    </section>
  );
}

export default BodyHashClusterSection;
